export default __webpack_public_path__ + "8f6ccd015551b197ca98f89b81bd5deb.svg";